import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { RefreshScheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/login",
    "home": false,
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "local"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new RefreshScheme($auth, {
  "token": {
    "property": "token"
  },
  "refreshToken": {
    "property": "refreshToken",
    "data": "refreshToken",
    "maxAge": 15552000
  },
  "user": {
    "property": "user",
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "/auth/portal-login",
      "method": "post"
    },
    "refresh": {
      "url": "/auth/refreshtoken",
      "method": "post"
    },
    "user": {
      "url": "/auth/user?appId=5",
      "method": "get"
    },
    "logout": {
      "url": "/auth/logout",
      "method": "post"
    }
  },
  "name": "local"
}))

  // switchUser
  $auth.registerStrategy('switchUser', new RefreshScheme($auth, {
  "token": {
    "property": "token"
  },
  "refreshToken": {
    "property": "refreshToken",
    "data": "refreshToken",
    "maxAge": 15552000
  },
  "user": {
    "property": "user"
  },
  "endpoints": {
    "login": {
      "url": "/auth/portal-login",
      "method": "post"
    },
    "refresh": {
      "url": "/auth/refreshtoken",
      "method": "post"
    },
    "user": {
      "url": "/auth/user?appId=5",
      "method": "get"
    },
    "logout": {
      "url": "/auth/logout",
      "method": "post"
    }
  },
  "name": "switchUser"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
